import { Button as DevButton } from 'devextreme-react/button';
import React, { useEffect, useState } from "react";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import SendBienLaiModal from './SendBienLaiModal';
import SendThongBaoPhiModal from './SendThongBaoPhiModal';

type ThuPhiSendBienLaiBtnProps = {
    disabled: boolean,
    printDisabled?: boolean,
    buttonText?: string,
    emailType?: 'bienlai' | 'thongbaophi',
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number,
    isNeedToShowPopUp?: boolean,
    onPopUpOpened?: () => void
}

const ThuPhiSendBienLaiBtn = (props: ThuPhiSendBienLaiBtnProps) => {
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>(props.isNeedToShowPopUp || false);

    useEffect(() => {
        if (props.isNeedToShowPopUp) {
            setIsShowPopUp(true);
            props.onPopUpOpened?.();
        }
    }, [props.isNeedToShowPopUp]);

    return (
        <>
            <DevButton
                text={props.buttonText || "Gửi email"}
                type="success"
                stylingMode="text"
                icon="todo"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPopUp(true);
                }}
            />
            {isShowPopUp && props.emailType === 'thongbaophi' && (
                <SendThongBaoPhiModal
                    onClose={() => {
                        setIsShowPopUp(false);
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    ts_hocsinh_id={props.ts_hocsinh_id}
                    printDisabled={props.printDisabled ?? props.disabled}
                    buttonText={props.buttonText}
                />
            )}
            {isShowPopUp && props.emailType !== 'thongbaophi' && (
                <SendBienLaiModal
                    onClose={() => {
                        setIsShowPopUp(false);
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    ts_hocsinh_id={props.ts_hocsinh_id}
                    printDisabled={props.printDisabled ?? props.disabled}
                    buttonText={props.buttonText}
                />
            )}
        </>
    );
}

export default ThuPhiSendBienLaiBtn;
